import { useEffect, useState } from "react";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

/**
 * A 2px accent line along the top of the viewport while something the user
 * is waiting on is in flight: a screen's first data, a filtered list, a save.
 * Background polls refresh data that is already on screen and stay silent.
 * The bar waits 150 ms before appearing, so a fast answer never flashes it.
 */
export function PendingBar() {
  const loading = useIsFetching({ predicate: (q) => q.state.data === undefined });
  const saving = useIsMutating();
  const busy = loading + saving > 0;
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!busy) {
      setShown(false);
      return;
    }
    const t = window.setTimeout(() => setShown(true), 150);
    return () => window.clearTimeout(t);
  }, [busy]);

  if (!shown) return null;
  return (
    <div role="progressbar" aria-label="Ładowanie" className="pointer-events-none fixed inset-x-0 top-0 z-[70] h-0.5 overflow-hidden">
      <div className="h-full w-1/3 rounded-full bg-accent-2 shadow-[0_0_8px_var(--color-accent-glow)] [animation:rp-bar_1.1s_var(--ease-rp)_infinite]" />
    </div>
  );
}
